import { render, staticRenderFns } from "./VRadiosPublic.vue?vue&type=template&id=60552f8a"
import script from "./VRadiosPublic.vue?vue&type=script&lang=js"
export * from "./VRadiosPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports